import React from "react";
import Hero from "../components/Hero";
import AboutPreview from "../components/AboutPreview";
import ProductsPreview from "../components/ProductsPreview";
import CTA from "../components/CTA";
import "../styles/home.css";

function Home() {
  return (
    <>
      <Hero />
      <AboutPreview />
      <ProductsPreview />
      <CTA />
    </>
  );
}

export default Home;
